import React from 'react';

import FieldWrapper from '../Field-wrapper';
import styles from '../Fields.module.less';

import AutoColumns from '$ContainersLegacy/Content/AutoColumns';
import { normalizeCSSID } from '$Validation/Normalizer';

/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
class CheckMultiFieldInput extends React.Component {
    render() {
        const {
            cols = 2,
            choices,
            exclusiveChoices,
            input: { onChange },
            value: fieldValue = []
        } = this.props;
        const disabledChoices = (() => {
            if (!exclusiveChoices) return [];
            if (!fieldValue || fieldValue.length === 0) return [];
            const exclusiveMatches = exclusiveChoices.filter(choiceValue =>
                fieldValue.includes(choiceValue)
            );
            if (exclusiveMatches.length === 0) return exclusiveChoices;
            if (exclusiveMatches.length === 1) {
                return choices
                    .filter(choice => {
                        return !fieldValue.includes(choice[0]); //[value, label]
                        //(choice !== exclusiveMatches[0])
                    })
                    .map(choice => choice[0]);
            }
            return exclusiveChoices;
        })();
        const handleChange = value => {
            if (fieldValue.includes(value)) {
                const valueString = value.toString();
                onChange(
                    fieldValue.filter(val => val.toString() !== valueString)
                );
            } else {
                //concat returns a copy of the array
                onChange(fieldValue.concat([value]));
            }
        };
        const checkboxes = choices.map(item => {
            let [value, label] = item;
            if (!value || !label) return null;
            const stringValue = value.toString();
            let id = normalizeCSSID(
                ['choice', this.props.id, stringValue].join('-')
            );

            const disabled = disabledChoices.includes(value);

            //Find out if it should appear as checked or not
            let checked =
                fieldValue &&
                fieldValue.some(
                    fieldVal => fieldVal.toString() === stringValue
                );
            const { labelCase, name } = this.props;
            const labelClassName =
                labelCase === 'uppercase' ? 'label' : `label-${labelCase}`;

            return (
                <div
                    className={[
                        styles['field'],
                        styles['check-field-multi-item']
                    ].join(' ')}
                    key={id}
                >
                    <input
                        className={styles['checkbox']}
                        checked={checked}
                        id={id}
                        disabled={disabled}
                        name={name}
                        onChange={() => handleChange(value)}
                        type="checkbox"
                        value={!!value}
                    />
                    <label
                        className={styles[labelClassName]}
                        style={disabled ? { cursor: 'not-allowed' } : undefined}
                        htmlFor={id}
                    >
                        <span>{label}</span>
                    </label>
                </div>
            );
        });
        return <AutoColumns cols={cols}>{checkboxes}</AutoColumns>;
    }
}
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export default FieldWrapper(CheckMultiFieldInput, { reduxForm: true });
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export const CheckMultiField = FieldWrapper(CheckMultiFieldInput);
